import React from 'react'
import BaseComponent from './BaseComponent'
import { NavLink } from 'react-router-dom'
import Footer from './Footer'
import _ from 'lodash'
import $ from 'jquery'
import Parsley from 'parsleyjs'
import Modal from './Modal'

export default class HomePage extends BaseComponent {

  constructor(props) {
    super(props)
    this.state = { activeReview: 0, activeSlide: 0, toggleReview: [false, false, false, false, false], email: "", name: "", phone: "", message: "", error: false, popup: false }
    this._bind('setReview', 'setSlide', 'handleInputChange', 'sendForm', 'submitForm', 'showError', 'showPopup', 'closeError', 'closePopup')

    Parsley.addMessages('pl', {
      defaultMessage: "Wartość wygląda na nieprawidłową",
      type: {
        email:        "Wpisz poprawny adres e-mail.",
        url:          "Wpisz poprawny adres URL.",
        number:       "Wpisz poprawną liczbę.",
        integer:      "Dozwolone są jedynie liczby całkowite.",
        digits:       "Dozwolone są jedynie cyfry.",
        alphanum:     "Dozwolone są jedynie znaki alfanumeryczne."
      },
      notblank:       "Pole nie może być puste.",
      required:       "Pole jest wymagane.",
      pattern:        "Pole zawiera nieprawidłową wartość.",
      min:            "Wartość nie może być mniejsza od %s.",
      max:            "Wartość nie może być większa od %s.",
      range:          "Wartość powinna zaweriać się pomiędzy %s a %s.",
      minlength:      "Minimalna ilość znaków wynosi %s.",
      maxlength:      "Maksymalna ilość znaków wynosi %s.",
      length:         "Ilość znaków wynosi od %s do %s.",
      mincheck:       "Wybierz minimalnie %s opcji.",
      maxcheck:       "Wybierz maksymalnie %s opcji.",
      check:          "Wybierz od %s do %s opcji.",
      equalto:        "Wartości nie są identyczne."
    });

    Parsley.setLocale('pl');
  }

  componentDidMount() {
    this.timer = setTimeout(this.setSlide.bind(null, this.state.activeSlide+1), 4000)
  }

  componentWillUnmount() {
    clearTimeout(this.timer)
  }

  setReview(i) {
    if (i >= 0 && (i < 5 && i < this.props.data.reviews.length)) {
      this.setState({ activeReview: i })
    }
  }

  setSlide(i) {
    if (i >= 0 && i < this.props.data.slider.length) {
      this.setState({ activeSlide: i })
    } else {
      this.setState({ activeSlide: 0 })
    }
    clearTimeout(this.timer)
    this.timer = setTimeout(this.setSlide.bind(null, this.state.activeSlide+1), 4000)
  }

  toggleReview(i) {
    let obj = this.state.toggleReview

    if (obj[i]) {
      obj[i] = false
    } else {
      obj[i] = true
    }

    this.setState({ toggleReview: obj })
  }

  showPopup() {
    this.setState({ popup: true })
  }

  showError() {
    this.setState({ error: true })
  }

  closePopup() {
    this.setState({ email: "", name: "", phone: "", message: "", error: false, popup: false })
  }

  closeError() {
    this.setState({ email: "", name: "", phone: "", message: "", error: false, popup: false })
  }

  handleInputChange(event) {
      const target = event.target
      let value = target.type === 'checkbox' ? target.checked : target.value
      let name = target.name

      this.setState({
        [name]: value
      })
  }

  sendForm(e) {
    e.preventDefault()

    if($('.form').parsley().validate()) {
      this.submitForm()
    }
  }

  submitForm() {

    let data = {
      title: "Formularz WWW - Formularz kontaktowy",
      name: this.state.name,
      phone: this.state.phone,
      email: this.state.email,
      message: this.state.message
    }

    fetch('/mailer/index.php', {
        method: "POST", 
        headers: {
            "Content-Type": "application/json; charset=utf-8"
        },
        body: JSON.stringify(data),
    })
    .then((response, status) => {
      return response.json()
    })
    .then((result) => {
      if (result.result === 0) {
        this.showError()
      } else {
        this.showPopup()
      }
    },(error) => {
      this.showError()
      console.log(error)
    })
  }

  render() {
    const page = _.filter(this.props.data.pages, { template: "homepage" })[0]

    const Popup = (
      <div className="popup-inner">
        <div className="close" onClick={ this.closePopup }></div>
        <h1>Dziękujemy</h1>
        <h4>Za zainteresowanie naszą ofertą</h4>
        <p>Skontaktujemy się z Państwem najszybciej jak to możliwe.</p>
        <button className="btn" onClick={ this.closePopup }><span>Zamknij</span><div className="close-modal"></div></button>
      </div>
    )

    const ErrorPopup = (
      <div className="popup-inner">
        <div className="close" onClick={ this.closeError }></div>
        <h1>Wystąpił błąd!</h1>
        <p>Prosimy spróbować ponownie.</p>
        <button className="btn" onClick={ this.closeError }><span>Zamknij</span><div className="close-modal"></div></button>
      </div>
    )

    let selectedReviews = this.props.data.reviews.slice(0, 5)

    let reviews = selectedReviews.map((item, i) => {
      return (
        <li key={ i } style={{ transform: "translateX(-" + this.state.activeReview*105 + "%)" }}>
          <div className="image">
            <img src={ item.logo ? item.logo : "/assets/img/user-icon.png" } alt={ item.title + " logo" }/>
          </div>
          <div className="text">
            <h4>{ item.title }</h4>
            <p>{ item.description.length > 200 && this.state.toggleReview[i] === false ? item.description.replace(/(([^\s]+\s\s*){30})(.*)/,"$1…") : item.description }</p>
            { item.description.length > 200 ? this.state.toggleReview[i] === false ? <span onClick={ () => { this.toggleReview(i) } }><strong>Więcej</strong></span> : <span onClick={ () => { this.toggleReview(i) } }><strong>Mniej</strong></span> : null }
          </div>
        </li>
      )
    })

    let reviewsDots = selectedReviews.map((item, i) => {
      return (
        <li key={ i } className={ i === this.state.activeReview ? "dot active" : "dot" } onClick={ this.setReview.bind(null, i) }></li>
      )
    })

    let slider = this.props.data.slider.map((item, i) => {
      return (
        <li key={ i } className={ this.state.activeSlide === i ? "slider-item active" : "slider-item" } style={{ backgroundImage: "url(" + item.background + ")" }}>
          <div className="text">
            <h1>{ item.title }</h1>
            <p>{ item.description }</p>
            <NavLink to={ item.link } className="btn white">Czytaj więcej</NavLink>
          </div>
          { item.image ? <img className="image" src={ item.image } alt={ item.title }/> : null }
        </li>
      )
    })

    let sliderDots = this.props.data.slider.map((item, i) => {
      return (
        <li key={ i } className={ this.state.activeSlide === i ? "slider-dot active" : "slider-dot" } onClick={ this.setSlide.bind(null, i) }></li>
      )
    })

    return (
      <section className="home">
        <div className="slider">
          <div className="container-big slider-inner">
            <ul className="slider-items">
              { slider }
            </ul>
          </div>
          <div className="slider-bottom">
            <div className="container">
              <ul className="slider-dots">
                { sliderDots }
              </ul>
            </div>
          </div>
        </div>
        <div className="offer">
          <div className="container">
            <ul className="offer-list">
              <li>
                <img src="/assets/img/home-icon-1.png" alt=""/>
                <h3 dangerouslySetInnerHTML={{ __html: page.additional_fields.icon1title }}></h3>
                <p dangerouslySetInnerHTML={{ __html: page.additional_fields.icon1desc }}></p>
                <NavLink to={ page.additional_fields.icon1link } className="btn">Czytaj więcej</NavLink>
              </li>
              <li>
                <img src="/assets/img/home-icon-2.png" alt=""/>
                <h3 dangerouslySetInnerHTML={{ __html: page.additional_fields.icon2title }}></h3>
                <p dangerouslySetInnerHTML={{ __html: page.additional_fields.icon2desc }}></p>
                <NavLink to={ page.additional_fields.icon2link } className="btn">Czytaj więcej</NavLink>
              </li>
              <li>
                <img src="/assets/img/home-icon-3.png" alt=""/>
                <h3 dangerouslySetInnerHTML={{ __html: page.additional_fields.icon3title }}></h3>
                <p dangerouslySetInnerHTML={{ __html: page.additional_fields.icon3desc }}></p>
                <NavLink to={ page.additional_fields.icon3link } className="btn">Czytaj więcej</NavLink>
              </li>
              <li>
                <img src="/assets/img/home-icon-4.png" alt=""/>
                <h3 dangerouslySetInnerHTML={{ __html: page.additional_fields.icon4title }}></h3>
                <p dangerouslySetInnerHTML={{ __html: page.additional_fields.icon4desc }}></p>
                <NavLink to={ page.additional_fields.icon4link } className="btn">Czytaj więcej</NavLink>
              </li>
            </ul>
          </div>
        </div>
        <div className="warranty container">
          <div className="image"><img src={ page.additional_fields.banner1img } alt=""/></div>
          <div className="text">
            <h1 dangerouslySetInnerHTML={{ __html: this.addColor(page.additional_fields.banner1title) }}></h1>
            <p>{ page.additional_fields.banner1desc }</p>
            <NavLink to={ page.additional_fields.banner1link } className="btn">Czytaj więcej</NavLink>
          </div>
        </div>
        <div className="banner">
          <div className="bg"></div>
          <div className="container">
            <div className="text">
              <h1 dangerouslySetInnerHTML={{ __html: this.addColor(page.additional_fields.banner2title) }}></h1>
              <p>{ page.additional_fields.banner2desc }</p>
              <NavLink to={ page.additional_fields.banner2link } className="btn">Czytaj więcej</NavLink>
            </div>
          </div>
        </div>
        <div className="home-reviews">
          <div className="container">
            <h1 dangerouslySetInnerHTML={{ __html: this.addColor(page.additional_fields.reviewstitle) }}></h1>
            <ul className="reviews-list">
              { reviews }
            </ul>
            <div className="controls">
              <ul className="dots">
                { reviewsDots }
              </ul>
              <NavLink to="/opinie" className="btn">Pokaż wszystkie</NavLink>
              <div className="prev-next">
                <span className={ this.state.activeReview === 0 ? "prev hide" : "prev" } onClick={ this.setReview.bind(null, this.state.activeReview-1) }><img src="/assets/img/chevron-gray.png" alt="chevron"/></span>
                <span className={ (this.state.activeReview < 5 && this.state.activeReview < this.props.data.reviews.length-1) ? "next" : "next hide" } onClick={ this.setReview.bind(null, this.state.activeReview+1) }><img src="/assets/img/chevron-gray.png" alt="chevron"/></span>
              </div>
            </div>
          </div>
        </div>
        <div className="container contact-bottom">
          <div className="contact-inner">
            <div className="contact-form">
              <h1 dangerouslySetInnerHTML={{ __html: this.addColor(page.additional_fields.contacttitle) }}></h1>
              <p>{ page.additional_fields.contactdesc }</p>
              <form className="form">
                <div className="inputs">
                  <div><input type="text" name="name" value={ this.state.name } onChange={ this.handleInputChange } placeholder="Imię i nazwisko" required/></div>
                  <div><input type="email" name="email" value={ this.state.email } onChange={ this.handleInputChange } placeholder="Adres e-mail" required/></div>
                  <div><input type="text" name="phone" value={ this.state.phone } onChange={ this.handleInputChange } placeholder="Numer telefonu" required/></div>
                </div>
                <textarea name="message" value={ this.state.message } onChange={ this.handleInputChange } placeholder="Treść wiadomości" required></textarea>
                <button className="btn" onClick={ this.sendForm }>Wyślij</button>
              </form>
            </div>
            <div className="contact-map">
              <img src="/assets/img/contact-bottom-map.png" alt="map"/>
            </div>
          </div>
        </div>
      	<Footer data={ this.props.data } settings={ this.props.data.settings }/>
        <Modal open={ this.state.popup } hidePopup={ this.closePopup }>{ Popup }</Modal>
        <Modal open={ this.state.error } hidePopup={ this.closeError }>{ ErrorPopup }</Modal>
      </section>
    )
  }
}


// WEBPACK FOOTER //
// ./src/app/components/HomePage.js